import { Building2, Truck } from "lucide-react";
import { Step } from "./Step";
import { fmtMoney } from "../../lib/format";

function Choice({ active, onClick, icon: Icon, title, sub, price, testId }) {
  return (
    <button type="button" onClick={onClick} data-testid={testId}
      className={`text-left p-5 border-2 rounded-sm transition-colors ${active ? "border-[#1E2A78] bg-[#1E2A78]/5" : "border-slate-200 hover:border-slate-300"}`}>
      <div className="flex items-center justify-between">
        <Icon className="h-6 w-6 text-[#1E2A78]" />
        <span className={`text-xs font-semibold px-2 py-0.5 rounded-sm ${active ? "bg-[#FFD700] text-[#1E2A78]" : "bg-slate-100 text-slate-600"}`}>{price}</span>
      </div>
      <div className="mt-3 font-semibold text-[#0F172A]">{title}</div>
      <div className="text-xs text-slate-500 mt-1">{sub}</div>
    </button>
  );
}

export function MethodStep({ method, setMethod, origin, liftgateFee, hasPallet }) {
  const cur = origin?.currency || "CAD";
  return (
    <Step n="3" title="How will we receive your items?" testId="quote-step-method">
      <div className="grid sm:grid-cols-2 gap-3">
        <Choice active={method === "dropoff"} onClick={() => setMethod("dropoff")} icon={Building2} title="Drop-off at our warehouse" sub="Mississauga, ON · Maple Ridge, BC · Miami, FL" price="Free" testId="quote-method-dropoff" />
        <Choice active={method === "pickup"} onClick={() => setMethod("pickup")} icon={Truck} title="Pickup at my door" sub="We come to you — flat fee based on your area" price={origin ? fmtMoney(origin.pickup_fee, cur) : "Fee applies"} testId="quote-method-pickup" />
      </div>
      {method === "pickup" && hasPallet && (
        <p className="mt-3 text-xs text-slate-600" data-testid="quote-liftgate-note">Pallet / crate pickup adds a {fmtMoney(liftgateFee, cur)} lift-gate truck fee.</p>
      )}
    </Step>
  );
}
